// extracted by mini-css-extract-plugin
export default {"card":"_155f3ElGEECFuwuNsgUiwF","cardTitle":"_13-CnqH7_h0BT6MzcdVA51","cardContent":"_1owklz9-6Cy5eWN3NqcyHU","table":"_3F7zDoJDX-XYBjaDCGKRkL"};